module.exports = __webpack_public_path__ + "static/media/background.6db46bb3.png";